import React from 'react';
import AsyncMultiSelect from './AsyncMultiSelect';
import { searchCountries } from '../api';

export default function CountriesSelect({ value, onChange, max = 10 }) {
  return (
    <AsyncMultiSelect
      label="Countries"
      placeholder="Search countries"
      value={value}
      onChange={onChange}
      searchFn={searchCountries}
      max={max}
    />
  );
}
